import { Tour, Hotel } from '@lt/components/icons-react/rebrand';

export const SEARCH_TYPE_NAMES = {
  PACKAGE: 'package',
  HOTEL: 'hotel',
} as const;

export const SEARCH_TYPES = [
  {
    name: SEARCH_TYPE_NAMES.PACKAGE,
    label: 'Туры',
    Icon: Tour,
  },
  {
    name: SEARCH_TYPE_NAMES.HOTEL,
    label: 'Отели',
    altLabel: 'Только проживание',
    Icon: Hotel,
  },
];
